function initImagesWithTextSection() {
  // Get all images with text sections
  const sections = document.querySelectorAll('.bb-reviews-grid');
  if (!sections.length) return;

  // Process each section
  sections.forEach((section) => {
    // Find the swiper container within this section
    const swiperContainer = section.querySelector('.bb-reviews-grid__swiper');
    if (!swiperContainer) return;

    // Find navigation elements inside this section
    const nextButton = section.querySelector('.bb-reviews-grid__nav--next');
    const prevButton = section.querySelector('.bb-reviews-grid__nav--prev');

    try {
      // Initialize swiper with responsive breakpoints
      new Swiper(swiperContainer, {
        slidesPerView: 1.2, // Default for smallest screens
        spaceBetween: 16,
        centeredSlides: false,
        initialSlide: 0,
        grabCursor: true,
        loop: false,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        breakpoints: {
          // Mobile (small phones)
          320: {
            slidesPerView: 1.1,
            spaceBetween: 12,
          },
          // Mobile (larger phones)
          480: {
            slidesPerView: 1.2,
            spaceBetween: 16,
          },
          // Tablets
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          // Desktop
          1024: {
            slidesPerView: 3,
            spaceBetween: 24,
            centeredSlides: false,
          },
          // Large Desktop
          1440: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
      });
    } catch (error) {
      console.error('Images with text swiper initialization failed:', error);
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  // Check if Swiper is available
  if (typeof Swiper === 'undefined') {
    console.warn('Swiper not found. Make sure swiper-bundle.min.js is loaded.');
    return;
  }

  // Initialize swiper only on desktop
  initReviewsGridSlider();

  // Handle resize events
  window.addEventListener('resize', function () {
    handleResponsiveSwiper();
  });

  // Initial check
  handleResponsiveSwiper();
});

// Track swiper instances
let reviewSwipers = [];

function initReviewsGridSlider() {
  // Find all review grid sliders
  const sliders = document.querySelectorAll('.bb-reviews-grid__desktop-slider');
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    const section = slider.closest('.bb-reviews-grid');
    const nextButton = section.querySelector('.bb-reviews-grid__nav--next');
    const prevButton = section.querySelector('.bb-reviews-grid__nav--prev');

    try {
      // Initialize desktop swiper
      const swiper = new Swiper(slider, {
        slidesPerView: 2,
        spaceBetween: 30,
        grabCursor: true,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        on: {
          init: function (sw) {
            if (sw.slides.length <= 1) {
              section.querySelector('.bb-reviews-grid__navigation').style.display = 'none';
            }
          },
        },
      });

      // Store reference to this swiper
      reviewSwipers.push(swiper);
    } catch (error) {
      console.error('Failed to initialize reviews grid slider:', error);
    }
  });
}

function handleResponsiveSwiper() {
  const isMobile = window.innerWidth < 992;

  // Show/hide navigation based on screen size
  document.querySelectorAll('.bb-reviews-grid__navigation').forEach((nav) => {
    nav.style.display = isMobile ? 'none' : 'flex';
  });

  // Disable/enable swiper on mobile
  reviewSwipers.forEach((swiper) => {
    if (isMobile) {
      if (swiper.enabled) {
        swiper.disable();
      }
    } else {
      if (!swiper.enabled) {
        swiper.enable();
      }
    }
  });
}
